export const MODEL = "MODEL";
export const getModel = (data) => {
    return {
        type: MODEL,
        payload: data
    }
}